import {
  GET_ADMIN_BY_ID,
  GET_ADMIN_LIST,
  GET_ROLE_HISTORY,
} from "../constants";

const INITIAL_STATE = {
  adminList: [],
  updateadmin: {},
  roleHistory: { history: [], pagination_meta: null },
};

export const admin = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_LIST:
      return { ...state, adminList: action.adminList };
    case GET_ADMIN_BY_ID:
      return { ...state, updateadmin: action.updateadmin };
    case GET_ROLE_HISTORY:
      return { ...state, roleHistory: action.roleHistory };
    default:
      return state;
  }
};
